import { Locale } from 'modules/i18n';

export const suspendedUserAlertTranslation = {
  [Locale.en]: {
    message:
      'Service suspended due to negative balance. Top up to resume blockchain interactions.',
  },
};
